import { initAnalytics } from '@codasc/analytics';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initPixel } from './track';
import './styles.css';

// Analytics first, so the event queue exists before anything can fire into it.
// No id (local dev, staging) means this does nothing and every later track()
// call no-ops — see @codasc/analytics.
initAnalytics({ measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID });

// The Meta pixel fetches its id at runtime and never blocks the render.
void initPixel();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

// No auth gate: this page is for people who have no Codasc account.
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
